 

export const drawer = {
  state: false,
  actions: {
    async drawerChange({commit},payload){
      commit('drawerChangeSuccess', payload)
      return payload;
    }
  },
  getters: {
    drawer: state => state
  },
  mutations: {
    drawerChangeSuccess(state, drawer) {
      state = drawer;
    }
  },   
};

export default drawer;



// WEBPACK FOOTER //
// ./src/store/drawer.module.js